
import { BaseIntegrationService } from "../../common/BaseIntegrationService";
import { InstagramIntegration } from "../types";

/**
 * Instagram integration service that extends the base integration service
 */
export class InstagramIntegrationService extends BaseIntegrationService<InstagramIntegration> {
  constructor() {
    super('instagram_integrations', 'Instagram Integration');
  }
  
  /**
   * Additional Instagram-specific methods can be added here
   */
  async updateInstagramSettings(
    aiStaffId: string, 
    settings: {
      instagram_username?: string;
      is_content_scheduling_enabled?: boolean;
      is_auto_responses_enabled?: boolean;
    }
  ): Promise<boolean> {
    return this.updateSettings(aiStaffId, settings);
  }
}

// Create a singleton instance of the service
export const instagramIntegrationService = new InstagramIntegrationService();
